export default [
  {
    path: '/world-cup',
    name: 'worldCup',
    component: () => {
      return import(
        /* webpackChunkName: "worldCup" */ '@/views/world-cup/index.vue'
      )
    },
    meta: {
      title: ''
    }
  },
  {
    path: '/world-cup/rule',
    name: 'rule',
    component: () => {
      return import(
        /* webpackChunkName: "worldCup" */ '@/views/world-cup/rule.vue'
      )
    },
    meta: {
      title: ''
    }
  }
]
